// Game-day playback: ONE <audio> element, unlocked by the tap that starts the
// sequence, then re-used for the clip. iOS only lets an element play inside a
// user gesture the first time; re-using the same element for the second track
// keeps it allowed. Audio blobs are prefetched so play() is synchronous.
export type Phase = "idle" | "announcing" | "walkup";

export class WalkupPlayer {
  private el = new Audio();
  private onPhase: (p: Phase) => void;
  private token = 0;

  constructor(onPhase: (p: Phase) => void) {
    this.onPhase = onPhase;
    this.el.preload = "auto";
  }

  /** Must be called synchronously from a user gesture. */
  play(announcementUrl: string | null, clipUrl: string | null): void {
    const my = ++this.token;
    const el = this.el;
    const step = (url: string | null, phase: Phase, next: () => void) => {
      if (!url) return next();
      if (my !== this.token) return;
      el.onended = () => { if (my === this.token) next(); };
      el.onerror = () => { if (my === this.token) next(); };
      el.src = url;
      this.onPhase(phase);
      void el.play().catch(() => next());
    };
    step(announcementUrl, "announcing", () => step(clipUrl, "walkup", () => this.stop()));
  }

  stop(): void {
    this.token++;
    this.el.pause();
    this.el.removeAttribute("src");
    this.el.load();
    this.onPhase("idle");
  }
}
